import {
    DynamicTaskPayload,
    DynamicTaskResponse,
} from '@/types/apps/dynamic-task.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Deletable } from '@/types/service/deletable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';
import type { Updatable } from '@/types/service/updatable.interface';

type DynamicTaskListResponse = ApiResponse<
    PaginatedResult<DynamicTaskResponse>
>;

export class DynamicTaskService
    implements Showable, Updatable, Deletable, Creatable, Indexable
{
    public constructor(private apiClient: BaseApiClientInterface) {}

    public endpoints = {
        base: () => '/api/task-template',
        detail: (id: string) => `/api/task-template/${id}`,
    };

    public index(params?: QueryParams): Promise<DynamicTaskListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<DynamicTaskResponse>> {
        return this.apiClient.fetchApi(this.endpoints.detail(id), params);
    }

    public create(
        payload: DynamicTaskPayload
    ): Promise<ApiResponse<DynamicTaskResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }

    public update(
        id: string,
        payload: DynamicTaskPayload
    ): Promise<ApiResponse<DynamicTaskResponse>> {
        return this.apiClient.putApi(this.endpoints.detail(id), payload);
    }

    public destroy(
        ids: string[],
        isHardDeleted: boolean = false
    ): Promise<ApiResponse<void>> {
        return this.apiClient.destroyApi(
            this.endpoints.base(),
            ids,
            isHardDeleted
        );
    }
}
